module.exports = __webpack_public_path__ + "img/auth1.e9d8c723.png";